import styled from "styled-components";
import {
  ButtonCreate,
  ButtonAlternative,
} from "../../styles-components/Buttons";

export const ListHeader = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 10px;

  div span {
    font-size: 2rem;
    color: var(--orange);
  }

  div ${ButtonAlternative} {
    margin-top: auto;
  }

  ${ButtonCreate} {
    text-align: right;
    margin-top: 10px;
    margin-left: auto;
  }

  @media (max-width: 760px) {
    flex-direction: column-reverse;

    ${ButtonCreate} {
      text-align: center;
    }

    div {
      align-self: center;
    }

    div span {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 570px) {
    div ${ButtonAlternative} {
      padding: 10px;
    }
  }
`;
